import RareBoxLogo from "Logos/RareBoxLogo";
import axios from "axios";
import { attrGrpAttrAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

const PimDashboardContext = createContext();

const PimDashboardProvider = () => {
	const [attrGroupsWithAttr, setAttrGroupsWithAttr] = useState();
	const [allAttributes, setAllAttributes] = useState();
	const [allAttributesObj, setAllAttributesObj] = useState();
	const [selectedStyle, setSelectedStyle] = useState();
	const [buyingList, setBuyingList] = useState("");
	const [distinctSizeMaster, setDistinctSizeMaster] = useState();
	const [sizeTypeMasterData, setSizeTypeMasterData] = useState([]);
	const [supplierList, setSupplierList] = useState([]);
	const [fabmaster, setFabMaster] = useState();
	const [trimsCatMaster, setTrimsCatMaster] = useState();
	const [trimsCatDescObj, setTrimsCatDescObj] = useState();
	const [valueAddCatDesc, setValueAddCatDescObj] = useState();
	const [commodityCatMaster, setCommodityCatMaster] = useState();
	const [placementMaster, setPlacementMaster] = useState();

	useEffect(() => {
		const fetch = async () => {
			try {
				await axios.get(`/api/attr_master/attr_grp_with_attrs`).then((res) => {
					let obj = res.data?.result?.length ? {} : null;
					let attrArr = [];
					let attrArrObj = {};
					res.data?.result?.forEach((row) => {
						obj[row.group_id] = { ...row };
						row[attrGrpAttrAssocObj].forEach((attr) => {
							attrArr.push(attr);
							attrArrObj = { ...attrArrObj, [attr?.key]: attr };
						});
					});
					console.log(obj, attrArr, "attrArrattrArrattrArr");

					if (obj) {
						setAttrGroupsWithAttr(obj);
						setAllAttributes(attrArr);
						setAllAttributesObj(attrArrObj);
					}
				});
			} catch (error) {
				console.log(error);
			}
		};
		fetch();
	}, []);

	return (
		<PimDashboardContext.Provider
			value={{
				attrGroupsWithAttr,
				setAttrGroupsWithAttr,
				allAttributes,
				setAllAttributes,
				allAttributesObj,
				setAllAttributesObj,
				selectedStyle,
				setSelectedStyle,
				buyingList,
				setBuyingList,
				distinctSizeMaster,
				setDistinctSizeMaster,
				sizeTypeMasterData,
				setSizeTypeMasterData,
				supplierList,
				setSupplierList,
				fabmaster,
				setFabMaster,
				trimsCatMaster,
				setTrimsCatMaster,
				setTrimsCatDescObj,
				trimsCatDescObj,
				valueAddCatDesc,
				setValueAddCatDescObj,
				commodityCatMaster,
				setCommodityCatMaster,
				placementMaster,
				setPlacementMaster,
			}}>
			{attrGroupsWithAttr ? (
				<Outlet />
			) : (
				<div
					style={{
						width: "160px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo width="100%" />
					<CustomLinearProgress height="4px" />
				</div>
			)}
		</PimDashboardContext.Provider>
	);
};

export const PimDashboardState = () => {
	return useContext(PimDashboardContext);
};

export default PimDashboardProvider;
